// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2of0n","toggleWrap":"styles_toggleWrap__36FwB","content":"styles_content__1Xpsy","selectAreaCode":"styles_selectAreaCode__1k94M"};